import Marquee from "react-fast-marquee";

export default function MarqueeBand() {
  const items = ["CRETEXA", "ENGINEERED TO ENDURE", "TG20 / TG30 COMPLIANT", "STEEL THAT STANDS"];
  return (
    <div className="border-y border-[#333] bg-[#0A0A0A] py-6 overflow-hidden" data-testid="marquee">
      <Marquee speed={40} gradient={false}>
        {[...items, ...items].map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-bold uppercase tracking-tight text-4xl lg:text-6xl text-white px-8">
              {t}
            </span>
            <span className="text-[#FF4D00] text-4xl lg:text-6xl font-display" aria-hidden="true">
              /
            </span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
